module.exports = __webpack_public_path__ + "media/assets/checkmark-499f9f3f77ae04eb6c1d1e28bd484797.svg";